/**
 * Individual impact area card component
 * Responsive design applied
 */
export function ImpactAreaCard({ title, items }: { title: string; items: string[] }) {
  return (
    <div className="3xl:p-[62px] 3xl:py-14 relative overflow-hidden rounded-2xl bg-white px-6 py-8 sm:px-10 sm:py-10 md:px-12 md:py-12">
      {/* Orange circle indicator */}
      <div className="absolute -left-10 top-7 h-8 w-14 rounded-full bg-bright-orange sm:-left-10 sm:top-12 sm:h-[43px] sm:w-[70px]"></div>

      {/* Title */}
      <h3 className="3xl:text-[40px] 3xl:leading-[40px] mb-4 text-xl font-bold leading-tight text-marine sm:text-2xl sm:leading-[32px] md:text-3xl md:leading-[36px]">
        {title}
      </h3>

      {/* Bullet list */}
      <ul className="ms-2 space-y-2">
        {items.map((item, itemIndex) => (
          <li
            key={itemIndex}
            className="3xl:text-2xl flex items-start gap-3 text-base text-marine/60 sm:text-lg md:text-xl"
          >
            <div className="max-h-8 sm:max-h-[32px]">
              <div className="ms-2 mt-4 size-1 flex-shrink-0 bg-marine/60 sm:mt-[18px]" />
            </div>
            <span>{item}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}